export default "/images/vendor/flag-icon-css/flags/4x3/bn.svg?ad7aafa9a29894397b43296e034a46ee";